import axiosConfig from '@lib/axiosConfig';

export const DepartmentService = {

    list: async function () {
        return await axiosConfig.get('/departments');
    },

    show: async function (id) {
        return await axiosConfig.get(`/departments/show/${id}`);
    },

    fetchbyfilter: async function (filter, order=null, limit=null) {
        return await axiosConfig.get(`/departments/fetchbyfilter/${filter}/${order}/${limit}`);
    },

    store: async function (data) {
        return await axiosConfig.post('/departments/store', data);
    },

    update: async function (data, id) {
        return await axiosConfig.put(`/departments/update/${id}`, data);
    },

    delete: async function (id) {
        return await axiosConfig.delete(`/departments/delete/${id}`);
    },

};